<template>
  <div>
    <!-- List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
    >
      <template v-slot:item.pergb_price="{ item }">
        ${{ item.pergb_price }} USD ({{ $t('global.perGB') }})
      </template>

      <template v-slot:item.bandwidth="{ item }">
        {{ item.bandwidth }} Mbits
      </template>

      <template v-slot:item.ip="{ item }">
        {{ item.ip_addr }} {{ item.subnet }}
      </template>
    </List>
  </div>
</template>

<script>
// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'GatewayVirtualZone',
  data() {
    return {
      loading: false,
      header: [
        { text: 'global.id', value: 'id' },
        { text: 'global.name', value: 'name' },
        { text: 'servers.trafficCost', value: 'pergb_price' },
        { text: 'servers.bandwidth', value: 'bandwidth' },
        { text: 'global.ipSubnet', value: 'ip' },
      ],
      data: [],
      pagination: {},
      meta: {},
    }
  },
  props: {
    vmId: {
      type: String,
      default: '',
    },
  },
  computed: {
    getVmId() {
      return this.vmId ? this.vmId : this.$route.params.id
    },
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true

      const { current_page } = this.meta

      let $query = `iaas/virtual-network-cards?virtualMachine=${this.getVmId}`

      ApiService.get($query)
        .then(({ data }) => {
          let firstData = data.data
          if (firstData) {
            let firstDataDevice = firstData.find((f) => f.device_number == 1)
            if (
              firstDataDevice &&
              firstDataDevice.network &&
              firstDataDevice.network.data
            ) {
              this.data = []
              this.data.push(firstDataDevice.network.data)
            }
          }

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    closeDetail() {
      this.showDetail = false
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
}
</script>
